import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";
import { useCallback } from "react";

export const useScrollToTop = () => {
  const scrollOffset = useEngineStore((state) => state.rootAttributes?.[RootAttribute.ScrollOffset]);

  return useCallback(() => {
    const offset = scrollOffset ? parseInt(scrollOffset, 10) : 0;
    window.scrollTo({ top: isNaN(offset) ? 0 : offset, behavior: "smooth" });
  }, [scrollOffset]);
};
